module.exports = __webpack_public_path__ + "media/recipes/108-d2ae6a3a.png";